module.exports = __webpack_public_path__ + "fcbcaf8db2dec39e8007f0e933381a44.png";